import { render, staticRenderFns } from "./view_grv.vue?vue&type=template&id=09d10dab&scoped=true"
import script from "./view_grv.vue?vue&type=script&lang=js"
export * from "./view_grv.vue?vue&type=script&lang=js"
import style0 from "./view_grv.vue?vue&type=style&index=0&id=09d10dab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d10dab",
  null
  
)

export default component.exports